import { Controller } from "@hotwired/stimulus"
import { get, getSlideUrl } from '../helpers'

export default class extends Controller {
  static values = { fetchUrl: String }

  async connect() {
    await get(this.fetchUrlValue, {
      query: { url: getSlideUrl() }
    })
  }
}
